// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EffortlessApp_thecomp__sULh8"};